import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'line-graph-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <circle
                    class="svgWrapperShape"
                    id="pdc-path-1"
                    cx="53"
                    cy="53"
                    r="53"
                />
            </defs>
            <g
                id="pdc-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="pdc-B-Person-page--more-people-added-"
                    transform="translate(-362.000000, -1862.000000)"
                >
                    <g
                        id="pdc-Group-12"
                        transform="translate(365.000000, 1865.000000)"
                    >
                        <g id="pdc-Screen-Shot-2019-01-14-at-5.33.33-PM">
                            <mask id="pdc-mask-2" fill="white">
                                <use xlink:href="#pdc-path-1" />
                            </mask>
                            <use
                                id="pdc-Mask"
                                stroke="#0092C8"
                                stroke-width="4.4"
                                fill="#F3FBFE"
                                fill-rule="nonzero"
                                xlink:href="#pdc-path-1"
                            />
                        </g>
                        <g
                            id="pdc-Group-7"
                            transform="translate(31.000000, 32.000000)"
                            fill="#3D1C70"
                        >
                            <polygon
                                id="pdc-Fill-1"
                                points="29.8064516 0 34.4698065 4.70687296 23.0322581 16.255131 14.9032258 8.0454689 0 23.0965162 2.87496774 26 14.9032258 13.8524366 23.0322581 22.0620987 37.3393548 7.61309336 42 12.3199663 42 0.00547310809"
                            />
                            <polygon
                                id="pdc-Fill-2"
                                points="34 17.4200542 34 43 39 43 39 12"
                            />
                            <polygon
                                id="pdc-Fill-3"
                                points="26 25.4529621 26 43 31 43 31 20"
                            />
                            <polygon
                                id="pdc-Fill-4"
                                points="18 43 23 43 23 28.3770668 18 23"
                            />
                            <polygon
                                id="pdc-Fill-5"
                                points="10 25.4529621 10 43 15 43 15 20"
                            />
                            <polygon
                                id="pdc-Fill-6"
                                points="2 33.5157198 2 43 7 43 7 28"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class LineGraphIconComponent {
    @Input()
    iconSize: IconSize;
}
